import { CartProductSchema } from '../../types';
import type { State } from '../types';

export function getOrgProductInstancesMap(state: State): Record<string, CartProductSchema[]> {
  const allProducts = Object.values(state.products);
  const orgProductInstancesMap = allProducts.reduce((acc, product) => {
    const orgId = product.parentEntitlementId;
    if (!orgId) {
      return acc;
    }
    if (!acc[orgId]) {
      acc[orgId] = [];
    }
    acc[orgId].push(product);
    return acc;
  }, {} as Record<string, CartProductSchema[]>);
  return orgProductInstancesMap;
}
